/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Settings_SavedInputs */

const en_consent_settings_saved = /** @type {(inputs: Consent_Settings_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consent preferences updated.`)
};

const de_consent_settings_saved = /** @type {(inputs: Consent_Settings_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einwilligungseinstellungen aktualisiert.`)
};

const fr_consent_settings_saved = /** @type {(inputs: Consent_Settings_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferences de consentement mises a jour.`)
};

const es_consent_settings_saved = /** @type {(inputs: Consent_Settings_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferencias de consentimiento actualizadas.`)
};

const it_consent_settings_saved = /** @type {(inputs: Consent_Settings_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferenze di consenso aggiornate.`)
};

const nl_consent_settings_saved = /** @type {(inputs: Consent_Settings_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toestemmingsvoorkeuren bijgewerkt.`)
};

const pl_consent_settings_saved = /** @type {(inputs: Consent_Settings_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferencje zgod zaktualizowane.`)
};

const fi_consent_settings_saved = /** @type {(inputs: Consent_Settings_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suostumusasetukset paivitetty.`)
};

const da_consent_settings_saved = /** @type {(inputs: Consent_Settings_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samtykkepraeferencer opdateret.`)
};

const sv_consent_settings_saved = /** @type {(inputs: Consent_Settings_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samtyckesinstallningar uppdaterade.`)
};

/**
* | output |
* | --- |
* | "Consent preferences updated." |
*
* @param {Consent_Settings_SavedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_settings_saved = /** @type {((inputs?: Consent_Settings_SavedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Settings_SavedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_settings_saved(inputs)
	if (locale === "fr") return fr_consent_settings_saved(inputs)
	if (locale === "es") return es_consent_settings_saved(inputs)
	if (locale === "it") return it_consent_settings_saved(inputs)
	if (locale === "nl") return nl_consent_settings_saved(inputs)
	if (locale === "pl") return pl_consent_settings_saved(inputs)
	if (locale === "fi") return fi_consent_settings_saved(inputs)
	if (locale === "da") return da_consent_settings_saved(inputs)
	if (locale === "sv") return sv_consent_settings_saved(inputs)
	return en_consent_settings_saved(inputs)
});